/**
 * @file center.js
 * @description Servicio público (sin auth) para fetchar datos de una
 *              Organization por su slug. Lo usa la pantalla de login con
 *              URL `/login/:orgSlug` para hidratar branding de la org
 *              ANTES de que el usuario logue, así no ve el logo del tenant
 *              durante el login (UC-REG-077).
 */

import axios from "axios";
import configService from "@/services/config";

const centerService = {};

/**
 * @description Trae datos públicos de un centro médico (org) por slug.
 *              No requiere auth — backend filtra orgs suspendidas.
 *              Usa axios crudo (no la instancia api) para evitar
 *              interceptors que requieren token.
 * @param {string} orgSlug - org.key (lowercase, e.g. "cnc")
 * @returns {Promise<Object|null>} center data o null si no existe
 */
centerService.getBySlug = async function (orgSlug) {
  if (!orgSlug) return null;
  try {
    const res = await axios.get(
      `${configService.apiUrl}/landing/center/${encodeURIComponent(orgSlug)}`
    );
    return res.data;
  } catch (e) {
    // 404 → org no existe → caller cae al login normal del tenant.
    return null;
  }
};

export default centerService;
